import { render, staticRenderFns } from "./VerDetalleCertificado.vue?vue&type=template&id=1afd73b6&scoped=true&"
import script from "./VerDetalleCertificado.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleCertificado.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleCertificado.vue?vue&type=style&index=0&id=1afd73b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afd73b6",
  null
  
)

export default component.exports